<template>
  <Loading :loading="loading">
  <div class="container">
    <div class="row col-12">

      <WordpressContentPage 
        pageSlug="petContestSubmission-top"
        class="col-12"
        :showLoading="false"
        v-on:loaded="wpContentLoaded"
      />

      <form
        class="row col-12"
        v-on:submit.prevent="submitCompetitionEntry"
      >
      
        <h3 class="col-12">You & Your Pet</h3>
        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          Your Full Name*
        </label>
        <input 
          class="form-control col-12 col-sm-8"
          v-model="details.name"
          v-validate="'required'"
          name="Name"
          autocomplete="on"
        >
        <div class="invalid-feedback">{{errors.first('Name')}}</div>

        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          Your Pet's Name*
        </label>
        <input 
          class="form-control col-12 col-sm-8"
          v-model="details.petsName"
          v-validate="'required'"
          name="PetsName"
        >
        <div class="invalid-feedback">{{errors.first('PetsName')}}</div>

        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          About your Pet
        </label>
        <textarea name="petDesc" v-model="details.petDesc" class="form-control col-12 col-sm-8"></textarea>

        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          Image*
        </label>
        <div 
          class="form-control col-12 col-sm-8" 
          id="imageContainer"
        >
          <label 
            id="imageLabel" 
            class="form-control col-12" 
            for="image" 
            v-html="(imageName?imageName:'Choose an image...')"
          >
          </label>
          <input 
            id="image" 
            type="file" 
            name="image" 
            v-validate="'required|image|size:10000'" 
            @change="onFileChange"
          >
        </div>
        <div class="invalid-feedback">{{errors.first('image')}}</div>

        <!-- Contact Details -->
        <h3 class="col-12">Contact Details</h3>
        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          Email*
        </label>
        <input 
          class="form-control col-12 col-sm-8"
          v-model="details.email"
          v-validate="'required|email'"
          name="Email"
          autocomplete="on"
        >
        <div class="invalid-feedback">{{errors.first('Email')}}</div>

        <label 
          class="col-12 col-sm-4"
        >
          Phone*
        </label>
        <input
          v-model="details.phone"
          type="tel"
          name="Phone"
          class="col-12 col-sm-8 form-control"
          autocomplete="on"
          v-validate="{required:true,regex:/^([+]?[0-9 ]+)$/}"
        >
        <div class="invalid-feedback">{{errors.first('Phone')}}</div>
        <!-- End Contact Details -->

        <!-- Postal Address -->
        <h3 class="col-12">Postal Address</h3>
        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          Street*
        </label>
        <input 
          class="form-control col-12 col-sm-8"
          v-model="details.address.street"
          v-validate="'required'"
          name="Street"
          autocomplete="on"
        >
        <div class="invalid-feedback">{{errors.first('Street')}}</div>

        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          Suburb
        </label>
        <input 
          class="form-control col-12 col-sm-8"
          v-model="details.address.suburb"
          name="Suburb"
          autocomplete="on"
        >

        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          City*
        </label>
        <input 
          class="form-control col-12 col-sm-8"
          v-model="details.address.city"
          v-validate="'required'"
          name="City"
          autocomplete="on"
        >
        <div class="invalid-feedback">{{errors.first('City')}}</div>

        <label 
          class="col-12 col-sm-4 col-form-label"
        >
          Post Code*
        </label>
        <input 
          class="form-control col-12 col-sm-8"
          v-model="details.address.postcode"
          v-validate="{required:true, regex: /^\d{4}$/}"
          name="PostCode"
          autocomplete="on"
        >
        <div class="invalid-feedback">{{errors.first('PostCode')}}</div>
        <!-- End Postal Address -->
        <div class="col-12">* = Required</div>
        


        <ButtonWithLoading
          class="mx-auto my-3"
          type="submit"
          :state="submitState"
          text="Submit"
          loadingText="Submitting"
          successText="Submitted"
          failureText="Problem Submitting"
          ref="submitButton"
        />

        <div id="completionText" class="col-12 text-sm-center" ref="completionText">
          Thank you for your submission. You have been successfully entered into the Cherrytree Pet of the Month Competition.
        </div>
      </form>
    </div>
  </div>
  </Loading>
</template>

<script>

import WordpressContentPage from "@/wordpress/WordpressContentPage";
import Loading from "@/components/loading/Loading";
import ButtonWithLoading from "@/components/buttonWithLoading";
import { postPetContestSubmission } from "@/network/contestRequests.js";

export default {
  name: 'PetsContestSubmissionForm',
  components: {
      Loading,
      WordpressContentPage,
      ButtonWithLoading
  },
  data(){
    return {
        loading: true,
        details: {
            name: "",
            petsName: "",
            petDesc: "",
            email: "",
            phone: "",
            address: {
                street: "",
                suburb: "",
                city: "",
                postcode: ""
            }
        },
        image: {
            mime: "",
            image: ""
        },
        imageName: "",
        submitState: null
    }
  },
  methods: {
    wpContentLoaded() {
        this.loading = false;
    },
    toBase64(file){
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){
        this.imageName=''
        this.image.image=''
        this.image.mime=''
        return;
      }
      this.imageName = files[0].name
      this.image.mime=files[0].type
      this.toBase64(files[0]).then((data) => {
        this.image.image=data
      })
    },
    submitCompetitionEntry() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        this.submitState = "loading";
        let { details, image } = this;
        postPetContestSubmission({ details, image },
          ()=>{ //success
            this.submitState = "success";
            setTimeout(() => {
              this.submitState = null;
            }, 5000);
          },
          error =>{  // This currently works because the post request responds as an error, and the minute it is fixed on the backend it's gonna break here
          // Just dealing with it for now as Mikael doesn't send the data as a response to the request, but does so through the generic interceptor.
          // This is just funny.
            if(error.data.petContest_submission && error.data.petContest_submission.success == true) {
              this.submitState = "success";
            } else {
              this.submitState = "error";
              console.log(error);
            }
            setTimeout(() => {
              this.submitState = null;
              if(error.data.petContest_submission && error.data.petContest_submission.success == true) {
                this.$refs.submitButton.$el.style="display:none;"
                this.$refs.completionText.style="display:block;"
              }
            }, 5000);
          }
        );
      });
    }
  }
}
</script>

<style lang="scss" scoped>

#image{
width: 0.1px;
height: 0.1px;
opacity: 0;
overflow: hidden;
position: absolute;
margin:0;
z-index: -1;
}
#imageLabel{
font-weight: 700;
color: white;
padding:10px;
height: auto;
background-color: #AF272F;
display: inline-block;
cursor: pointer;
margin: 0;
}
#image:focus #imageLabel, #imageLabel:hover{
background-color: #902027;
}

#imageContainer{
border:none;
height: auto;
padding-left:0;
padding-right:0;
}

#completionText {
  display: none;
  font-weight: 600;
  font-size: 1.25rem;
  margin-top: 20px;
}

</style>
